class RenderHtml extends HTMLElement {
  static get observedAttributes () { return ['html'] }

  attributeChangedCallback () {
    const html = this.getAttribute('html')
    if (html && html !== this.innerHTML) {
      this.innerHTML = html
    }
  }
}

customElements.define('render-html', RenderHtml)
